// Eine Farbtabelle für alle Status: Close-Farbname -> eigene, dezente Töne (Werte in styles/tokens.css, --status-<name>-bg/-fg).
// Listen, Lead-Kopf, Verlauf und Auswahlen benutzen dieselbe Zuordnung; neue Farbe = ein Eintrag hier plus zwei Variablen in tokens.css.
export const STATUS_FARBEN = ["gray", "blue", "green", "magenta", "orange", "purple", "teal", "yellow", "gold", "slate", "red", "darkred"] as const;
export type StatusFarbe = (typeof STATUS_FARBEN)[number];

const BEKANNT = new Set<string>(STATUS_FARBEN);

export function statusFarbe(farbe: string | null | undefined): StatusFarbe {
  return farbe && BEKANNT.has(farbe) ? (farbe as StatusFarbe) : "gray";
}

/** Lead Score (Bronze / Silber / Gold): Stufe aus einem Feldwert, sonst null. */
export type ScoreStufe = "bronze" | "silber" | "gold";
export function scoreStufe(wert: unknown): ScoreStufe | null {
  const t = (Array.isArray(wert) ? String(wert[0] ?? "") : String(wert ?? "")).toLowerCase();
  if (/\bbronze\b/.test(t)) return "bronze";
  if (/\bsilber\b|\bsilver\b/.test(t)) return "silber";
  if (/\bgold\b/.test(t)) return "gold";
  return null;
}

/** Farben der Lead-Status nach Name (mit Dilsar abgestimmt, Design-Runde 2). Terminiert Gold · Kunde Grün · Follow-UP und
 *  Nachbesprechung Orange · Erstkontakt und Kaltakquise - Neu Blau · Nicht Erreicht und Kaltakquise - Nicht erreicht
 *  Grau-Blau · Kein Bedarf, Unqualifiziert, UQ - Bad Data, Nicht gekauft Rot · Blacklist Dunkelrot · Ex-Kunde Grau ·
 *  Wichtig Violett. Gleiche Farben in Listen, Kopf und Verlauf; unbekannte Status behalten die Farbe aus Close. */
const NACH_NAME: Record<string, StatusFarbe> = {
  terminiert: "gold",
  kunde: "green",
  kunden: "green",
  "follow-up": "orange",
  followup: "orange",
  nachbesprechung: "orange",
  erstkontakt: "blue",
  "kaltakquise - neu": "blue",
  "nicht erreicht": "slate",
  "kaltakquise - nicht erreicht": "slate",
  "kein bedarf": "red",
  unqualifiziert: "red",
  "uq - bad data": "red",
  "nicht gekauft": "red",
  blacklist: "darkred",
  "ex-kunde": "gray",
  wichtig: "purple",
};

/** Die Farbe, die gilt: eine im CRM ausdrücklich gewählte Farbe (nicht leer, nicht „gray“) gewinnt, die Namenstabelle nur für leere und graue. */
export function wirksameStatusFarbe(name: string | null | undefined, farbe: string | null | undefined): string | null {
  if (farbe && farbe !== "gray") return farbe;
  return statusFarbeNachName(name) ?? farbe ?? null;
}

/** Rein: Farbe für einen Status-Namen aus der Tabelle oben, sonst null. Emojis und Satzzeichen am Rand zählen nicht. */
export function statusFarbeNachName(name: string | null | undefined): StatusFarbe | null {
  const roh = (name ?? "").toLowerCase().replace(/[^a-zäöüß0-9 -]/g, " ").replace(/\s+/g, " ").trim();
  return NACH_NAME[roh] ?? null;
}
